import { CpdEnvironment } from './environment.interface';

export const environment: CpdEnvironment = {
  production: false,
  envName: 'DEV',
  // REST endpoints live on the gateway domain (same place as streamUri / genViaStatusUri).
  // Posting to dev.careerpathdecide.org/api/* hits the SPA's CloudFront and gets rewritten to index.html.
  apiUrlBase: 'https://api-dev-gateway.careerpathdecide.org/api/',
  apiOccupationMicroservice: 'https://api-occupation.datastop.io/api',
  stackOverflowOnError: false,
  showUnderConstructionSign: false,
  enableNewFeatures: true,
  /*
   * PL-5. Deliberately null, not a Universal Analytics id.
   *
   * This carried a UA property id. Universal Analytics stopped processing data
   * in July 2023, so it measured nothing for over three years while looking
   * fully instrumented.
   *
   * The SERVICE already refuses a UA id and says so loudly -- DS-T16 fixed
   * that, and the QA sweep's PL-5 describes the configuration rather than the
   * behaviour. This aligns the configuration with what the code already does,
   * so nobody reading the environment file concludes analytics are on here.
   *
   * To turn analytics on for this environment, put a GA4 measurement id
   * (G-...) here. Nothing else needs to change.
   */
  googleAnalyticsTrackingId: null, // was 'UA-167347566-2'
  graphQlUri: 'https://api-dev-gateway.careerpathdecide.org/graphql',
  streamUri:
    'https://api-dev-gateway.careerpathdecide.org/api/chatbot/stream-direct',
  genViaStatusUri:
    'https://api-dev-gateway.careerpathdecide.org/api/ai-report/stream-status',
  widgetUrl: 'https://dev-widget.returnon.college',
  clientUrl: 'https://dev.careerpathdecide.org',
  datastopInstitutionGraphqlUri:
    'https://dev-api.datastop.io/institutions/graphql',
  authConfig: {
    Cognito: {
      userPoolId: 'us-east-2_BItGNX1iy',
      userPoolClientId: '5js1nj1le6cb9s6iuucmfnn2vg',
      loginWith: {
        oauth: {
          domain: 'dev-login.careerpathdecide.org',
          scopes: ['email', 'openid', 'profile'],
          // INFRA-1: development-dantes is the dev rehearsal of the DANTES
          // dedicated URL. It has to be listed here as well as on the Cognito
          // app client, because Amplify checks this list in the browser before
          // it ever contacts Cognito. Adding it to Cognito alone leaves the
          // social sign-in buttons dead with an InvalidOriginException.
          //
          // Order note: none of these hostnames is a substring of another, so
          // Amplify's substring fallback cannot mismatch them. On prod, where
          // www and dantes both contain the apex, order is load-bearing. See
          // environment.oauth-redirects.spec.ts.
          redirectSignIn: [
            'http://localhost:4200',
            'https://dev.careerpathdecide.org',
            'https://development-dantes.careerpathdecide.org'
          ],
          redirectSignOut: [
            'http://localhost:4200',
            'https://dev.careerpathdecide.org',
            'https://development-dantes.careerpathdecide.org'
          ],
          responseType: 'code'
        }
      }
    }
  },
  mxdSponsorMapping: [
    {
      id: 'eb178358-9c19-40f1-a27e-26da000e2136',
      name: 'CyberSecurity Analyst - SMM'
    },
    {
      id: '280bf560-f8a5-4491-817b-39db08b24435',
      name: 'Supply Chain Cybersecurity Compliance Specialist'
    },
    {
      id: '9b828069-4520-4d17-826e-26f12daca677',
      name: 'Manufacturing Analytics Associate'
    },
    {
      id: 'd7a1e52b-b27e-4085-b2d2-5b43c1ee8028',
      name: 'Pre-Metaverse Integration Technologist'
    },
    {
      id: '77f47d9c-fac1-4da9-a8f1-46da8a688688',
      name: 'Data Annotator'
    }
  ],
  mxdId: '3b3ef8cf-f6d9-4cec-9c47-dc8cd5ec7f74',
  mxdSignUpLink: 'https://vtc.mxdusa.org/?KeyName=yDCekdX.sGFZa75xVDye'
};
